import { render, staticRenderFns } from "./AdvBuyerSpaceDocs.vue?vue&type=template&id=7fc2147d&"
import script from "./AdvBuyerSpaceDocs.vue?vue&type=script&lang=js&"
export * from "./AdvBuyerSpaceDocs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports